import * as dayjs from 'dayjs';

export const toDateAsString = (date: Date, mask: string = 'MM/DD/YYYY') => {
  return dayjs(date).format(mask);
};

export const toDateTimeAsString = (date: Date, mask: string = 'MM/DD/YYYY hh:mm aa') => {
  return dayjs(date).format(mask);
};

export const isValidDate = (date: any) => {
  return dayjs(date).isValid();
};

export const dayjsUTC = (date: Date | string) => {
  const utc = require('dayjs/plugin/utc');
  dayjs.extend(utc);

  return dayjs['utc'](date);
};

export const dayjsTimezone = (date: Date | string, tz: string) => {
  const utc = require('dayjs/plugin/utc');
  const timezone = require('dayjs/plugin/timezone');

  dayjs.extend(utc);
  dayjs.extend(timezone);

  return dayjs.tz(date, tz);
};
